<template>
  <div @load="loading">
    <div class="gameplay_title_container">
      <div class="gameplay_title">
        {{ gameInfo.question }}
      </div>
    </div>
    <div class="gameplay_game_box_list gameplay_tap_box att8" >


      <div class="gameplay_btns_row" v-for="(row, rowindex) in twoDimensionalTable" :key="rowindex">
        <div :disabled="buttonPushed" type="" class="knot_box" v-for="(col, colindex) in row"
             :key="rowindex-colindex" :style="disableDiv"
             @click.prevent="sendAnswer(rowindex, colindex)"
             :ref="rowindex === 0 ? (colindex + 1) : (rowindex * numOfCols) + (colindex + 1)">
          <img :src=col>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

/* eslint no-console: "off" */
import { mapState, mapGetters } from 'vuex';
import NewGameMixin from '@/common/mixins/home';
import { ParseResponseMixin, GameMixin2 } from '@/common/mixins/game';
import { gameplayFooter } from '@/common/jQuery';

export default {
  name: 'AttentionRollingListQuiz',
  mixins: [NewGameMixin, ParseResponseMixin, GameMixin2],
  data() {
    return {
      gameInfo: null, // NEW
      twoDimensionalTable: [], // NEW
      numOfRow: 0,
      numOfCols: 0,
      buttonPushed: false,
    };
  },
  mounted() {
    this.$nextTick(() => { this.loading(); });
  },
  created() {
    this.initGameData();
  },
  methods: {
    loading() {
      gameplayFooter();
    },
    initGameData() {
      this.gameInfo = this.miniGames[this.currentMiniGameRound];
      this.createMatrix();
    },
    createMatrix() {
      this.numOfRow = this.gameInfo.answerList.length / 2;
      this.numOfCols = this.gameInfo.answerList.length / 2;
      let indexOfCorrectAnswer = 0;
      this.twoDimensionalTable = Array(this.numOfRow).fill().map(() => Array(this.numOfCols).fill(''));
      for (let i = 0; i < this.numOfRow; i += 1) {
        for (let j = 0; j < this.numOfCols; j += 1) {
          this.twoDimensionalTable[i][j] = this.gameInfo.answerList[indexOfCorrectAnswer].card.url;
          indexOfCorrectAnswer += 1;
        }
      }
    },
    sendAnswer(answerRow, answerCol) {
      const answersIndex = answerRow === 0 ? answerCol + 1 : (answerRow * this.numOfCols) + answerCol + 1;
      if (this.buttonPushed) {
        console.log('--> User 2 times. Wait for Answer....');
      } else {
        let isCorrectAnswer = false;
        this.buttonPushed = true;
        this.$axios({
          url: `api/sendAnswerBrainiac?gameId=${this.gameID}&miniGameId=${this.gameInfo.id}&answerIndex=${answersIndex - 1}`,
          method: 'GET',
          headers: {
            Authorization: this.jwtInVuex,
          },
        }).then((response) => {
          const responseData = response.data.data;
          if (response.data.responseEnum === 'OPERATION_SUCCESS') {
            if (responseData.status === 'WRONG_ANSWER') {
              this.$refs[answersIndex][0].classList.add('gameplay_btn_false');
              this.$refs[this.gameInfo.correctIndex + 1][0].classList.add('gameplay_btn_correct');
            } else if (responseData.status === 'CORRECT_ANSWER') {
              isCorrectAnswer = true;
              this.$refs[answersIndex][0].classList.add('gameplay_btn_correct');
            } else {
              // something bad happened
            }
          }
          setTimeout(() => {
            this.normalTransition = true;
            this.storeBrainiacGameData(isCorrectAnswer);
            this.$refs[answersIndex][0].classList.remove('gameplay_btn_false');
            this.$refs[answersIndex][0].classList.remove('gameplay_btn_correct');
          }, 1500);
        }).catch((error) => {
          console.log(`Invoking api/sendAnswer failed with the following error: ${error}`);
        });
      }
    },
  },
  computed: {
    ...mapState('profile', [
      'jwtInVuex',
    ]),
    ...mapState('game', [
      'gameID',
      'gameType',
      'miniGames',
      'currentMiniGameRound',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    disableDiv() {
      return !this.buttonPushed ? 'cursor:pointer' : 'pointer-events:none';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/attention/AttentionRollingListQuiz.vue